export default {
  install: (Vue) => {
    Vue.prototype.$dateFunctions = {
      formatDate (obj) {
        let d = false
        if (!obj.date) {
          d = new Date()
        } else {
          d = new Date(obj.date)
        }
        if (!obj.format) {
          obj.format = 'yyyy-mm-dd'
        }
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        let year = d.getFullYear()
        if (month.length < 2) { month = '0' + month }
        if (day.length < 2) { day = '0' + day }

        // if obj.format == 'yyyy-mm-dd'
        let r = [year, month, day].join('-')
        return r
      },
      setOffset (dt) {
        var dn = new Date()
        var n = dn.getTimezoneOffset()
        var offset = n * 60 * 1000
        dt.setTime(dt.getTime() + offset)
        return dt
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Dates.js